import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Card } from '@material-ui/core';
import styled from 'styled-components';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import ContentOne from './Accordion/Content';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import reducer from 'app/store/reducers/members';
import reducerProjects from 'app/store/reducers/projects';
import clsx from 'clsx';
import { useDebounce } from 'app/main/customHooks/useDebounce';
import { useLocation } from 'react-router-dom';

/** DISPLAY THE DROPDOWN WITH ACCORDION COMPONENT */
const StyledButtonMobile = styled(Button)`
    background-color: white; 
    color: grey; 
    width: 100%;
    text-transform: initial;  
`;
const StyledButton = styled(Button)`
    background-color: white; 
    color: grey; 
    //width: 30vw;
    width:100%;
    text-transform: initial;  
`;


const useStyles = makeStyles(theme => ({
	containerTitle: {
		background: '#FAFAFA',
		boxShadow: '0px 3px 5px 0px rgba(0,0,0,0.15)',
	},
	projectSelector:{
		width:'100%'
	},
	styleProjectSelector:{
		position: 'absolute', 
		display: 'block', 
		marginTop: 10, 
		width: '23vw',
		[theme.breakpoints.down('md')]:{
			width:'37vh',
		},
		[theme.breakpoints.down('sm')]:{
			width:'28vh',
		},
		[theme.breakpoints.down('xs')]:{
			width:'22vh',
		},
		zIndex:'99'
	},
	titleAccordion:{
		color: theme.palette.scaiPro.primary,
		fontSize: '1.3rem',
		fontWeight:'bold',
	},
	expanded: {
		margin: "0 auto!important",
	},
	iconAccordion:{
		color:'#BFBFBF',
		fontSize:'2.2rem',
		marginRight:'10px',
	},
	iconAccordionExpanded:{
		color: theme.palette.scaiPro.secondary,
		fontSize:'2.2rem',
		marginRight:'10px',
	},
	styleProjectName:{
		color:theme.palette.scaiPro.main,
		fontWeight: 'bold',
	},
	iconResetProject:{
		fontSize: '1.5rem',
		color: theme.palette.scaiPro.primary,
	},
	styleProjectTxt:{
		color: theme.palette.scaiPro.main,
		flex: 1,
		overflow: 'hidden',
		minWidth: 0,
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
}));


//:: Autocomplete Dropdown using Group By
/*function NewProjectSelect(){
	// const dispatch = useDispatch();
	const {t} = useTranslation('sharedComponentsPage');
	// const classes = useStyles();
	const  = useSelector(({ projectSelectorApp_projects }) => projectSelectorApp_projects.projects.projectSelectAPI?.projects);

	return(
		<Autocomplete
			id="grouped-demo"
			options={projectSelectAPI}
			groupBy={(option) => option.project_branch_name}
			getOptionLabel={(option) => option.projectName}
			style={{ width: 300 }}
			renderInput={(params) => {
				return <TextField {...params} label={t('select_project')} variant="outlined" />
			}}
		/>
	)
}*/

/** 支店名でグルーピング（イミュータブル） */
function groupBy(arr, prop) {
	return arr.reduce((acc, obj) => {
		const key = obj[prop];
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(obj);
		return acc;
	}, {});
}

const BRANCH_SORT_ORDER = [
	'札幌支店',
	'東北支店',
	'北陸支店',
	'首都圏土木支店',
	'東京支店',
	'関東支店',
	'名古屋支店',
	'大阪支店',
	'四国支店',
	'広島支店',
	'九州支店',
	'本社',
	'拠点なし',
	'現場',
	'東京',
	'Tokyo',
	'Tokyo Site Office',
	'千葉',
	'Chiba',
	'京都',
	'Kyoto',
	'大阪 01',
	'Osaka',
	'Osaka 01',
];

function buildGroupedBranches(data) {
	if (!data || !data.length) {
		return null;
	}
	const groupedArr = groupBy(data, 'project_branch_name');
	const groupedArrays = Object.entries(groupedArr);
	const sortedGroupedArrays = [...groupedArrays].sort((a, b) => {
		const aBranchName = a[0];
		const bBranchName = b[0];
		const aIndex = BRANCH_SORT_ORDER.indexOf(aBranchName);
		const bIndex = BRANCH_SORT_ORDER.indexOf(bBranchName);
		const aRank = aIndex === -1 ? BRANCH_SORT_ORDER.length : aIndex;
		const bRank = bIndex === -1 ? BRANCH_SORT_ORDER.length : bIndex;
		return aRank - bRank;
	});
	return sortedGroupedArrays.map((item) => ({
		branch_name: item[0],
		projects: item[1],
	}));
}

/** 展開中（または検索中は全展開）の支店だけプロジェクト一覧をマウントして INP を改善 */
function ProjectBranchAccordionList({ groupedBranches, searchText, expanded, debouncedValue, classes, handleChange }) {
	if (!groupedBranches || !groupedBranches.length) {
		return null;
	}
	return groupedBranches.map((item, index) => {
		const searchActive = searchText.length !== 0;
		const accordionExpanded = searchActive ? true : expanded === index;
		const mountProjects = searchActive || expanded === index;
		return (
			<Accordion
				key={item.branch_name || `branch-${index}`}
				expanded={accordionExpanded}
				classes={{ expanded: classes.expanded }}
				onChange={handleChange(index, item.branch_name)}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls={`panel1bh-content-${index}`}
					id={`panel1bh-header-${index}`}
					className={classes.containerTitle}
				>
					<RiCheckboxCircleFill
						className={expanded === index ? classes.iconAccordionExpanded : classes.iconAccordion}
					/>
					<Typography className={classes.titleAccordion}>{item.branch_name}</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{mountProjects ? (
						<ContentOne searchText={debouncedValue} projectBranch={item.projects} />
					) : null}
				</AccordionDetails>
			</Accordion>
		);
	});
}

function ProjectSelector() {
	const dispatch = useDispatch();
	const location = useLocation();
	const {t} = useTranslation('sharedComponentsPage');
	//const projectBranch = useSelector(({ projectSelectorApp }) => projectSelectorApp.members.members_getProjectBranch.result);
	const [display, setDisplay] = useState(false);
	const [searchText, setSearchText] = useState('');
	const ref = useRef();
	const classes = useStyles();
	const handleClick = () => {
		setDisplay(true);
	};

	//const handleMembers_projectSelected = useSelector(({projectSelectorApp}) => projectSelectorApp.members.handleMembers_projectSelected);
	const [projectModeCTM, setProjectModeCTM] = useState(false);
	const members_selectedProjectName = useSelector(({ projectSelectorApp }) =>  projectSelectorApp.members.members_selectedProjectName);
	const [selectProjectName, setSelectProjectName] = useState('');
	const [expanded, setExpanded] = useState(false);
	const [, setSelectedBranch] = useState('');
	const [panel1, setPanel1] = useState('');
	const projectSelectedValues =  JSON.parse(localStorage.getItem('persistProjectSelected'));
	const projectSelectAPI = useSelector(({ projectSelectorApp_projects }) => projectSelectorApp_projects.projects.projectSelectAPI?.projects);
	const debouncedValue = useDebounce(searchText, 250);
	const [filteredItems, setFilteredItems] = useState(null);

	useOnClickOutside(ref, () => setDisplay(false));

	const handleChange = (panel, name) => (event, isExpanded) => {
		setSelectedBranch(name);
		setExpanded(isExpanded ? panel : false);
		setPanel1(panel);
	};

	const handleSearch = (ele) => {
		if(ele.target.value !== '') {
			setExpanded(panel1);
		}
		setSearchText(ele.target.value);
	}

	//::Auto Close
	useEffect(()=>{
		if(members_selectedProjectName){
			setDisplay(false);
		} 
	},[members_selectedProjectName]);


	useEffect(()=>{
		projectSelectedValues && dispatch(Actions.handleMembers_projectSelected(projectSelectedValues));
		projectSelectedValues && dispatch(Actions.members_selectedProjectName(projectSelectedValues.projectName));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[projectSelectedValues]);

	useEffect(()=>{
		projectSelectedValues && setSelectProjectName(projectSelectedValues.projectName);
	},[projectSelectedValues]);

	//::Filtering Raw Data for CTM and NO-CTM Projects
	const ctmProjectSelectAPI = projectSelectAPI?.filter((element) => element.project_type.uuid === 'c6a22e66-db0d-4c59-9c27-7dcb9888150e') //Montain Tunnel CTM UUID
	//const regularProjectSelectAPI = projectSelectAPI?.filter((element) => element.project_type.name !== 'Mountain tunnel')
	// const groupedArr = projectSelectAPI && groupBy(projectSelectAPI, 'project_branch_name');
	// const groupedArrays = groupedArr && Object.entries(groupedArr);
	//const finalGroupedValuesAPI = groupedArrays && groupedArrays.map(item => { return {'branch_name':item[0], 'projects' : item[1]}});

	//Getting CTM UUID 
	const currentProjectName = projectSelectedValues?.project_type?.uuid;
	
	useEffect(()=>{
		//FOR CTM
		if(location.pathname.startsWith('/ctm')){
			
			if(currentProjectName !== 'c6a22e66-db0d-4c59-9c27-7dcb9888150e'){
				dispatch(Actions.members_selectedProjectName(''));
				dispatch(Actions.handleMembers_projectSelected(''));
				dispatch(Actions.getMembers(localStorage.getItem('persistCompanyID'), ''));
				dispatch(Actions.getSideMenuItems());
				// setTimeout(()=>{
				// 	dispatch(Actions.getSideMenuItems());
				// },500)
				localStorage.setItem('persistProjectUUID', '');
				localStorage.setItem('persistProjectSelected', JSON.stringify(''));
			}
			setProjectModeCTM(true);
		}else{
			//REGULAR PROJECTS
			setProjectModeCTM(false);

			//Reset CTM Projects 
			dispatch(Actions.resetCTM());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[location.pathname]);

	useEffect(()=>{
		if(projectModeCTM){
			const filteredList = ctmProjectSelectAPI?.filter((item) =>
				item.projectName.toLowerCase().includes(debouncedValue.toLowerCase()) ||
				item.project_branch_name.toLowerCase().includes(debouncedValue.toLowerCase()) ||
				item.projectCode.toLowerCase().includes(debouncedValue.toLowerCase())
        	);
        	setFilteredItems(filteredList);
		}else{
			const filteredList = projectSelectAPI?.filter((item) =>
				item.projectName.toLowerCase().includes(debouncedValue.toLowerCase()) ||
				item.project_branch_name.toLowerCase().includes(debouncedValue.toLowerCase()) ||
				item.projectCode.toLowerCase().includes(debouncedValue.toLowerCase())
			);
        	setFilteredItems(filteredList);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[debouncedValue, projectSelectAPI, projectModeCTM]);

	const groupedBranches = useMemo(() => buildGroupedBranches(filteredItems), [filteredItems]);

	return (
		<>
			{/* <AccordionWithSearch data={accordionData} /> */}
			{/* <NewProjectSelect/> */}
			<div /*style={{display:'none'}}*/ className={classes.projectSelector}>
				<Hidden lgUp>
					<StyledButtonMobile variant="outlined" color="primary" onClick={handleClick} >
						<span className={classes.styleProjectTxt}>{ (!members_selectedProjectName ) || (!selectProjectName)  ? t('select_project') : selectProjectName}</span>	
					</StyledButtonMobile>
				</Hidden>
				<Hidden mdDown>
					<StyledButton variant="outlined" color="primary" onClick={handleClick} >
						<span className={classes.styleProjectTxt}>{ (!members_selectedProjectName ) || (!selectProjectName) ?  t('select_project') : selectProjectName}</span>
					</StyledButton>
				</Hidden>
				{/* Displaying dropdown */}
				{display && (
					<>
						{/* TABLET AND MOBILE */}
						<Hidden lgUp>
							<div style={{ position: 'absolute', display: 'block', marginTop: 10,zIndex:'99'}} ref={ref}>
								<Card >
									<Paper variant="outlined" className={"flex p-4 items-center w-full h-40 px-8 py-4 border-gray-300 shadow-none "}>
										<Icon color="action">search</Icon>
										<Input
											placeholder={t('search_project')}
											className={clsx(classes.search, "flex flex-1 px-16")}
											disableUnderline
											fullWidth
											onChange={handleSearch}
											value={searchText}
										/>
									</Paper>
									<ProjectBranchAccordionList
										groupedBranches={groupedBranches}
										searchText={searchText}
										expanded={expanded}
										debouncedValue={debouncedValue}
										classes={classes}
										handleChange={handleChange}
									/>
								</Card>
							</div>
						</Hidden>


						{/* DESKTOP */}
						<Hidden mdDown>
							<div className={classes.styleProjectSelector} ref={ref}>
								<Card >
									<Paper variant="outlined" className={"flex p-4 items-center h-40 border-gray-300 shadow-none ml-8 mr-8 mt-8 mb-8"}>
										<Icon color="action">search</Icon>
										<Input
											placeholder={t('search_project')}
											className={clsx(classes.search, "flex flex-1 px-16")}
											disableUnderline
											fullWidth
											onChange={handleSearch}
											value={searchText}
										/>
									</Paper>
									<ProjectBranchAccordionList
										groupedBranches={groupedBranches}
										searchText={searchText}
										expanded={expanded}
										debouncedValue={debouncedValue}
										classes={classes}
										handleChange={handleChange}
									/>
								</Card>
							</div>
						</Hidden>
					</>
				)}
			</div>
		</>
	);
}

function useOnClickOutside(ref, handler) {
	useEffect(() => {
		const listener = (event) => {
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}
			handler(event);
		};

		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [ref, handler]);
}

export default withReducer('projectSelectorApp_projects', reducerProjects)(
	withReducer('projectSelectorApp', reducer)(React.memo(ProjectSelector))
);